import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';

interface APIQueryParam {
  [key: string]:
    | string
    | number
    | undefined
    | null
    | boolean
    | ReadonlyArray<string | number | boolean>;
}

interface SanitizedQueryParams {
  [key: string]:
    | string
    | number
    | boolean
    | ReadonlyArray<string | number | boolean>;
}
interface APIBody {
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class ApiService {
  private _url = environment.apiUrl;

  private _http = inject(HttpClient);
  constructor() {}

  get<T = unknown>(path: string, _params: APIQueryParam = {}) {
    const sanitizedQueryParams = this._sanitizeQueryParams(_params);

    const httpParams: HttpParams = new HttpParams({
      fromObject: sanitizedQueryParams,
    });
    return this._http
      .get<T>(this._url + path, {
        params: httpParams,
      })
      .pipe(
        catchError((res) => {
          return throwError(() => res.error);
        }),
      );
  }

  post<T = unknown>(path: string, body: APIBody) {
    return this._http.post<T>(this._url + path, body).pipe(
      catchError((res) => {
        return throwError(() => res.error);
      }),
    );
  }

  delete<T = unknown>(path: string, body: APIBody = {}) {
    return this._http.delete<T>(this._url + path, { body }).pipe(
      catchError((res) => {
        return throwError(() => res.error);
      }),
    );
  }

  patch<T = unknown>(path: string, body: APIBody = {}) {
    return this._http.patch<T>(this._url + path, body).pipe(
      catchError((res) => {
        return throwError(() => res.error);
      }),
    );
  }

  put<T = unknown>(path: string, body: APIBody = {}) {
    return this._http.put<T>(this._url + path, body).pipe(
      catchError((res) => {
        return throwError(() => res.error);
      }),
    );
  }
  getFile<T = unknown>(path: string, _params: APIQueryParam = {}) {
    const sanitizedQueryParams = this._sanitizeQueryParams(_params);

    const httpParams: HttpParams = new HttpParams({
      fromObject: sanitizedQueryParams,
    });
    return this._http
      .get<T>(this._url + path, {
        params: httpParams,
        responseType: 'blob' as any,
      })
      .pipe(
        catchError((error) => {
          // eslint-disable-next-line no-console
          console.error('API request failed:', error);
          return throwError(() => error.error);
        }),
      );
  }

  // Clean Object from falsy values.
  private _sanitizeQueryParams(params: APIQueryParam) {
    for (const param of Object.keys(params)) {
      const value = params[param];

      if (value == undefined || value == null || value == '')
        delete params[param];
    }

    return params as SanitizedQueryParams;
  }
}
